import {
    POST
} from "../util";

const inspectionUrl = "api/invoice-inspection";

const url = {
    inspection: {
        listInvoices: `${inspectionUrl}/list-invoices`,
        listCreditNotes: `${inspectionUrl}/list-creditnotes`
    }
};


const invoiceManagementApi = {
    inspection: {
        listInvoices: (params = {}) => {
            return POST(url.inspection.listInvoices, params);
        },
        listCreditNotes: (params = {}) => {
            return POST(url.inspection.listCreditNotes, params);
        },
    }
};
export {
    invoiceManagementApi
};